module.exports = __webpack_public_path__ + "static/media/video.1d9e8144.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Millard/video.mp4
// module id = 267
// module chunks = 0